import { AccountCircle, Refresh } from "@mui/icons-material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton/CustomButton";
import css from "./InactiveUser.module.css";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

const InactiveUser: FC<object> = function ({}) {
  const navigate = useNavigate();

  useDocumentTitle("Account Not Activated");

  const handleRefresh = () => {
    navigate("/refresh-status");
  };

  return (
    <div className={css.container}>
      <AccountCircle className={css.icon} fontSize="inherit" />
      <h2>Account Not Activated</h2>
      <p>
        Your account has not been activated yet. It should be activated within
        24 hours.
      </p>
      <p>
        If you believe this is an error, please contact us at
        accounts@unrulycorp.com
      </p>
      <CustomButton
        onClick={handleRefresh}
        icon={Refresh}
        intent="primary"
        size="default"
        variant="filled"
        className={css.refreshButton}
      >
        Try Again
      </CustomButton>
    </div>
  );
};

export default InactiveUser;
